export default __webpack_public_path__ + "static/media/dragon.9d32757b.svg";